export const metadata_for_main_dashboard: {
    [key: string]: {
      title: string;
      header: string;
      chartColor: string;
    };
  } = {
    "OEE": {
      "title": "OEE",
      "header": "OEE",
      "chartColor":"#fcf6bd",
    },
    "Availability": {
      "title": "Availability",
      "header": "Machines Availability",
      "chartColor":"#ffd166",
      
    },
    "Scrap": {
      "title": "Scrap",
      "header": "Machines Scrap",
      "chartColor":"#ef233c",
    },
    "PerformanceLosses":{
      "title": "Performance Losses",
      "header": "Machines Performance Losses",
      "chartColor":"#9b2226",
    },
    "Performance":{
      "title": "Performance",
      "header": "Machines Performance",
      "chartColor":"#95d5b2",
    },
    "Efficience": {
      "title": "Efficience",
      "header": "Efficience",
      "chartColor":"#fcf6bd",
    },
    "ProductionHours": {
      "title": "Production Hours",
      "header": "Production Hours",
      "chartColor":"#fcf6bd",
    }
  };

